/* eslint-disable i18next/no-literal-string */
export default {

    CLIENT_URLS: {
        'localhost': 'beta',
        'yotoplay.local': 'dev',
        'dev.mobile.aws.fooropa.com': 'dev',
        'mobile-dev.aws.fooropa.com': 'dev',
        'test.mobile.aws.fooropa.com': 'test',
        'mobile-test.aws.fooropa.com': 'prod',
        'mobile.web.yotoplay.com': 'beta',
        'mobile-beta.web.yotoplay.com': 'beta',
        'mobile-beta.yotoplay.com': 'beta',
        'mobile.yotoplay.com': 'prod'
    },

    API_DOMAINS: {
        dev: 'https://dev.aws.fooropa.com',
        test: 'https://test.aws.fooropa.com',
        beta: 'https://api.yotoplay.com',
        prod: 'https://api.yotoplay.com',
    },

    MEDIA_DOMAINS: {
        dev: 'https://yoto-card-api-dev-media.s3.eu-west-2.amazonaws.com',
        test: 'https://yoto-card-api-test-media.s3.eu-west-2.amazonaws.com',
        beta: 'https://yoto-card-api-prod-media.s3.eu-west-2.amazonaws.com',
        prod: 'https://yoto-card-api-prod-media.s3.eu-west-2.amazonaws.com'
    },

    DEVICE_PREFIXES: {
        dev: { v1: 'dev_', v2: 'd2' },
        test: { v1: 'test_', v2: 't2' },
        beta: { v1: '', v2: 'y2' },
        prod: { v1: '', v2: 'y2' }
    }
};
